
export default {
    methods: {

        compare(a,b) {
            if (a.sport.order === b.sport.order) {
                // Price is only important when cities are the same

                if(a.region.order === b.region.order){
                    if (a.competition.order === b.competition.order) {
                        // Price is only important when cities are the same
                        return 1;
                    }
                     return a.competition.order > b.competition.order ? 1 : -1;
                }
                return a.region.order > b.region.order ? 1 : -1;

             }
             return a.sport.order > b.sport.order  ? 1 : -1;
        },
        fetchLiveEvents (filter) {
            return this.$http.get( bsapi+'/api/v2/fixture/full', {
                params: filter
            })
        },
        compileList(Result) {

            Result.forEach(e => {
                if (e.competition.order == 99) {
                    e.competition.order = e.competition.id

                    if (e.onLive) {
                        e.competition.order = e.competition.id
                    }

                    if (e.markets.length == 0) {
                        e.marketCount = 0
                    }
                }
            })

            Result = Result.sort(this.compare)

            var VirtualList = [];
            var Sport = 0;
            var Competition = 0;
            var Region = 0;
            var TimePeriod = '';

            //var TimeP = moment().format('YYYY-MM-DD');

            Result.forEach(e => {
                
                if(e.sport.id != Sport){
                    VirtualList.push({
                        type: 'sport',
                        id: e.sport.id,
                        alias: e.sport.alias,
                        name: (e.sport.nameLn.name !== '') ? e.sport.nameLn.name : e.sport.name
                    })
                    Sport = e.sport.id;
                }

                if(e.region.id != Region){
                    VirtualList.push({
                        type: 'region',
                        id: e.region.id,
                        sport: e.sport.id,
                        name: (e.region.nameLn.name !== '') ? e.region.nameLn.name : e.region.name,
                        n: e.region.name,
                        regionCode: "int",
                        class1: " ",
                        class2: " ",
                        class3: " ",
                    })
                    Region = e.region.id;
                }

                if(e.competition.id != Competition){
                
                    VirtualList.push({
                        type: 'competition',
                        name: (e.competition.nameLn.name !== '') ? e.competition.nameLn.name : e.competition.name,
                        id: e.competition.id,
                        sport: {
                            sportId: e.sport.id,
                            name: (e.region.nameLn.name !== '') ? e.region.nameLn.name : e.region.name,
                            alias: e.sport.alias
                        },
                        region: {
                            n:  e.region.name,
                            id: e.region.id,
                            name: (e.region.nameLn.name !== '') ? e.region.nameLn.name : e.region.name,
                        }
                    })
                    Competition = e.competition.id;
                }

                var TimeP = moment(e.startedAt).format('YYYY-MM-DD');

                if(TimeP != TimePeriod){
                    VirtualList.push({
                        type: 'timeperiod',
                        period: TimeP
                    })

                    TimePeriod = TimeP;
                }

                var Stat = {};
                var Score = {};

                if(e.stat !== '')
                    Stat = JSON.parse(e.stat);

                if(e.stat !== '')
                    Score = JSON.parse(e.data);

                if(e.providerId == 7){
                    delete Stat["2nd half"];
                }
                    

                VirtualList.push({
                    type: 'event',
                    name: e.home.name+ ' - '+e.away.name,
                    sport: {
                        sportId: e.sport.id,
                        name: e.sport.name,
                        alias: e.sport.alias
                    },
                    region: {
                        name: e.region.name,
                        id: e.region.id
                    },
                    competition: {
                        id: e.competition.id,
                        name: e.competition.name
                    },
                    competitor: {
                        one: e.home.id,
                        oneEid: e.home.eid,
                        two: e.away.id,
                        twoEid: e.away.eid,
                        oneName: (e.home.nameLn.name !== '') ? e.home.nameLn.name : e.home.name,
                        twoName: (e.away.nameLn.name !== '') ? e.away.nameLn.name : e.away.name,
                    },
                    id: e.id,
                    rid: e.radarId,
                    matchId: e.id,
                    extendedId: e.extendedId,
                    minBetLimit: e.minBetLimit,
                    marketCount: e.marketCount,
                    betCount: e.betCount,
                    isActive: e.isLive,
                    isSuspended: e.isSuspended,
                    onLive: e.onLive,
                    highlighted: e.highlighted,
                    scoreboardType: 1,
                    resultName: e.result.name,
                    data: {
                        infos: {
                            stats: Stat
                        },
                        score: Score.score
                    },
                    startDate: e.startedAt,
                    createdAt: e.createdAt,
                    updatedAt: e.updatedAt,
                    periodTime: e.periodTime,
                    roundCounter: e.roundCounter,
                    periodTimeLeft: e.periodTimeLeft,
                    odds: this.marketCompile(e),
                    providerId: e.providerId,
                    ts: e.ts,
                    streamEmbed: e.streamEmbed,
                    goal: (e.goal) ? 1 : 0

                })

               // console.log(JSON.parse(e.stat))

            });

            return VirtualList;

        },
        eventCompile(e) {

            var Stat = {};
            var Score = {};

            if(e.stat !== '')
                Stat = JSON.parse(e.stat);

            if(e.stat !== '')
                Score = JSON.parse(e.data);

            return {
                type: 'event',
                name: e.home.name+ ' - '+e.away.name,
                sport: {
                    sportId: e.sport.id,
                    name: e.sport.name,
                    alias: e.sport.alias
                },
                region: {
                    name: e.region.name,
                    id: e.region.id
                },
                competition: {
                    id: e.competition.id,
                    name: e.competition.name
                },
                competitor: {
                    one: e.home.id,
                    oneEid: e.home.eid,
                    two: e.away.id,
                    twoEid: e.away.eid,
                    oneName: (e.home.nameLn.name !== '') ? e.home.nameLn.name : e.home.name,
                    twoName: (e.away.nameLn.name !== '') ? e.away.nameLn.name : e.away.name,
                },
                id: e.id,
                rid: e.radarId,
                matchId: e.id,
                extendedId: e.extendedId,
                minBetLimit: e.minBetLimit,
                marketCount: e.marketCount,
                betCount: e.betCount,
                isActive: e.isLive,
                isSuspended: e.isSuspended,
                onLive: e.onLive,
                highlighted: e.highlighted,
                scoreboardType: 1,
                resultName: e.result.name,
                data: {
                    infos: {
                        stats: Stat
                    },
                    score: Score.score
                },
                startDate: e.startedAt,
                createdAt: e.createdAt,
                updatedAt: e.updatedAt,
                periodTime: e.periodTime,
                roundCounter: e.roundCounter,
                periodTimeLeft: e.periodTimeLeft,
                odds: this.marketCompile(e),
                providerId: e.providerId,
                ts: e.ts,
                streamEmbed: e.streamEmbed
            }
        },
        marketCompile(e){
            
            var Markets = [];
            var Bundle = {};

            if(e.markets) {

                e.markets.forEach((m) => {

                    var arg = null
                    if(m.a != ""){
                        arg = {}
                        arg = JSON.parse(m.a).args
                    }

                    m.special = m.s
                    var hcp = ''
                    var type = window.marketType['m_'+m.t];
                    var Name = (type.nameLn.name !== '') ? type.nameLn.name : type.n;
                    var hcpi = (m.s > 0) ? '-'+Math.abs(m.s) : '+'+Math.abs(m.s)
    
                    if(e.providerId == 2){
                        if( ( type.n.match('Handicap') ) && e.sport.id == 1){
                            hcp = (m.s > 0) ? "0:"+Math.abs(m.s) : Math.abs(m.s)+":0"
                            Name += ' '+hcp
                            m.special = ''
                        }else if( ( !Name.match('{hcp}') && type.n.match('Handicap') ) && e.sport.id > 1){
                            hcp = hcpi
                            Name += ' '+hcp
                            m.special = ''
                        }
                    }

                    if (e.providerId == 5 && type.n.match('andicap')){
                        if( ( arg["{hcp}"] && !arg["{hcp}"].match(':') )){
                            hcp = (m.s < 0) ? "0:"+Math.abs(m.s) : Math.abs(m.s)+":0"
                           // if (arg["{hcp}"] !== 'undefined')
                           //     hcp = arg["{hcp}"];

                            Name += ' '+hcp
                            m.special = ''
                        }else if (!type.n.match('{')) {
                            Name += ' '+arg["{hcp}"]
                        }
                    }
                    if (e.providerId == 3){
                        hcpi = (m.s < 0) ? '-'+Math.abs(m.s) : '+'+Math.abs(m.s)
                        if(type.n.match('Handicap')){
                            hcp = (m.s < 0) ? "0:"+Math.abs(m.s) : Math.abs(m.s)+":0"
                            Name += ' '+hcp
                            m.special = ''
                        }
                    }

                    if (e.providerId == 5){
                        hcpi = (m.s < 0) ? '-'+Math.abs(m.s) : '+'+Math.abs(m.s)
                    }

                    if(typeof m.s === 'string')
                        m.special = m.s.replace('.0', '')
    
                    if (type.eid === 5500 && e.onLive && e.sport.id == 1) {
                        Name = this.$root.t.fixture.main_markets['TOTAL_REST']
                        m.special = Math.abs(e.ts - m.s)
                    }else if (type.eid === 5520 && e.onLive) {
                        Name = this.$root.t.fixture.main_markets['TOTAL_HT_REST']
                        m.special = Math.abs(e.ts - m.s)
                    }else {
    
                        /*
                        if(type.n.match('{h}')){
    
                            Name = Name.replace('{h}', m.s)
        
                        }else if(type.n.match('Total') || (m.s && (e.providerId == 7 || e.providerId == 3))){
                            if(arg['{pw}'] != m.s)
                                Name += ' '+m.s
                        } */
                    }

                    m.selections.forEach((s) => {
                        if(!Name.match(m.special) && (s.outcome.includes("-") || s.outcome.includes("+") || s.outcome == 'LOW' || s.outcome == 'HIGH' || s.outcome == 'Under' || s.outcome == 'Over'))
                            Name += ' '+m.special
                    })

                    if(arg){
                        const allKeys = Object.keys(arg);
                        allKeys.forEach((v) => {
                            Name = Name.replace(v, arg[v])
                        })

                        Name = Name.replace('{sw}', arg['{sw}'])
                        Name = Name.replace('{s}', arg['{s}'])
                        Name = Name.replace('{pw}', arg['{pw}'])
                        Name = Name.replace('{p}', arg['{p}'])
                        Name = Name.replace('{hv}', arg['{hv}'])
                        Name = Name.replace('{av}', arg['{av}'])
                        Name = Name.replace('{h}', arg['{sw}'])
                        Name = Name.replace('Team 1', e.home.name)
                        Name = Name.replace('Team 2', e.away.name)
                        Name = Name.replace('Player 1', e.home.name)
                        Name = Name.replace('{$competitor1}', e.home.name)
                        Name = Name.replace('{$competitor2}', e.away.name)
                        if (m.seq !== '')
                            Name = Name.replace('{%player}', m.seq)
                    }

                    if(!arg){
                        arg = {}
                        Name = Name.replace('{sw}', '')
                        Name = Name.replace('{s}', '')
                        Name = Name.replace('{pw}', '')
                        Name = Name.replace('{p}', '')
                        Name = Name.replace('{hv}', '')
                        Name = Name.replace('{av}', '')
                    }

                    if(e.providerId != 2 || e.providerId != 3){
                        Name = Name.replace('(undefined)', '')
                        Name = Name.replace('()', '')
                        Name = Name.replace('(-)', '')

                        if(typeof m.special === 'string'){
                            m.special = m.special.split(' ')[0]
                        }
                    }

                    var Market = {
                        name: Name,
                        order: type.order,
                        sw: arg['{sw}'],
                        show: true,
                        id: m.id,
                        disabled: m.disabled,
                        closed: false,
                        live: false,
                        sp: m.special,
                        specialKey: type.spk,
                        hcp: hcp,
                        hcpi: hcpi,
                        market: type.eid,
                        mid: type.id,
                        oddl: (type.minOdds > 0) ? true : false,
                        minodd: type.minOdds,
                        markets: (type.mg !== '') ? JSON.parse(type.mg) : [],
                        odd: [],
                        ts: e.ts,
                        bundle: false,
                        seq: m.seq,
                        n: (type.nameLn.name !== '') ? type.nameLn.name : type.n
                    }

                    var marketCount = 0;
                    m.selections.forEach((s) => {

                        if(s.special != "" && (type.eid == 38 || type.eid == 39 || type.eid == 40) && e.providerId == 5){
                            s.outcome = s.special
                        }

                        if (m.seq !== '')
                            s.outcome = s.outcome.replace('{%player}', m.seq)

                        if (type.eid == 882 && s.outcome == "no")
                            s.value = 1


                        const findByOddId = (data, oddId) => {
                            const searchId = typeof oddId === 'string' ? parseInt(oddId) : oddId;
                            return data.find(bet => bet.oddId === searchId) || null;
                        };

                        Market.odd.push({
                            id: s.id,
                            oddType: type.eid,
                            outcome: this.outcomeFix(s.outcome),
                            odd: s.value,
                            order: s.order,
                            active: (!s.isDisabled && !s.isClosed) ? true : false,
                            special: s.special,
                            selected: (window.selectedOdds && findByOddId(window.selectedOdds, s.id)) ? true : false
                        })       

                        if(s.value <= 1)
                            marketCount++
                    })

                    if(!e.onLive && (type.eid == 888 || type.eid == 882 || type.eid == 38 || type.eid == 39 || type.eid == 40) && e.providerId == 5)
                        Market.closed = true

                    if(marketCount != m.selections.length )
                        Markets.push(Market)

                    if(marketCount != m.selections.length && m.seq !== ''){
                        if(!Bundle['b_'+type.eid]) {
                            Bundle['b_'+type.eid] = new Array
                        }
                        Bundle['b_'+type.eid].push(Market)
                    }

                    if ((type.eid == 38 || type.eid == 39 || type.eid == 40) && !e.onLive) {
                        if(!Bundle['b_'+38]) {
                            Bundle['b_'+38] = {markets: Market.markets, outcomes: [], list: []}
                        }
                        Bundle['b_'+38].list.push(Market)
                        
                        Market.odd.forEach((v,i) => {

                            if (!v.outcome.match('goal') ){
                                //if(!Bundle['b_'+38]['o_'+v.outcome]) {
                                    //Bundle['b_'+38]['o_'+v.outcome] = {n: v.special}
                                //}
                                if(!Bundle['b_'+38].outcomes.includes(v.special))
                                    Bundle['b_'+38].outcomes.push(v.special)
                                
                                var sel = JSON.parse(JSON.stringify(v));
                                if (v.special != ''){
                                    sel.outcome = v.special
                                }
                                //Bundle['b_'+38]['o_'+v.outcome]['m'].push({market: Market, odd: sel, order: type.eid})
                            }

                        }) 
                        //Bundle['b_'+38].push(Market)
                    }
                    
                })
    
            }


            for (var k in Bundle){

                var sel = JSON.parse(JSON.stringify(Bundle[k]));
                delete sel.markets
                var Market = {
                    id: k.replace('b_', ''),
                    bundle: sel,
                    name: '',
                    market: 38,
                    markets: [53],
                    oddl: false,
                    sp: 0,
                    order: 38,
                    odd: []
                }
               Markets.push(Market)
            }
        
            return this.sortAByKey(Markets, 'order');
        },
        outcomeFix(outcome, arg) {

            var Find = ['1 or X', '1 or 2', 'X or 2','or more', 'W1', 'Draw', 'W2', 'Over', 'Under', 'Team 1', 'Team 2', 'No Goal',
        '{t1} ({-h})', 'Tie: {t2} ({h})', '{t2} ({h})', 'Yes', 'No', 'and', 'or', 'Exactly', '({h})', 'And', '{t1}', '{t2}', 'Odd', 'Even', 
        'All Periods The Same', '1st Half', '2nd Half', 'Any Other Sc|e', 'Neither', 'T1 1>2', 'T1 1=2', 'T1 2>1', 'T2 1>2', 'T2 1=2', 'T2 2>1',
    'HOME', 'TIE', 'AWAY', 'GG', 'NG', 'YES', 'NO', 'Y', 'N', 'Other', 'T1', 'T2', 'T3', 'T4', 'T5', 'LOW', 'HIGH', 'none', 'yes', 'no',];
            var Replace = ['1X', '12', 'X2', '| +','1', 'X', '2', '+', '-', '1', '2', 'X', '1', 'X', '2', '+', '-', '&', '|', 'X', '', '&', '1', '2', '1', '2', 'X',
        '1', '2', '++', 'X', '1', 'X', '2', '1', 'X', '2', '1', 'X', '2', this.t.selection.yes, this.t.selection.no, this.t.selection.yes, this.t.selection.no
        , this.t.selection.yes, this.t.selection.no, this.t.selection.other, 1, 2, 3, 4, 5, '-', '+', '0', this.t.selection.yes, this.t.selection.no];

            Find.forEach((v,i) => {
                outcome = outcome.replaceAll(v, Replace[i])
            })

            return outcome
        },
        ordinal_suffix_of(i) {
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return i + "st";
            }
            if (j == 2 && k != 12) {
                return i + "nd";
            }
            if (j == 3 && k != 13) {
                return i + "rd";
            }
            return i + "th";
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/fixture.js